function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["vue-confetti"] = e() : t["vue-confetti"] = e();
}(window, function () {
  return function (t) {
    var e = {};

    function n(i) {
      if (e[i]) return e[i].exports;
      var r = e[i] = {
        i: i,
        l: !1,
        exports: {}
      };
      return t[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, i) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: i
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
      var i = Object.create(null);
      if (n.r(i), Object.defineProperty(i, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var r in t) {
        n.d(i, r, function (e) {
          return t[e];
        }.bind(null, r));
      }
      return i;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 3);
  }([function (t, e, n) {
    "use strict";

    n.r(e);

    var i = function i() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
          e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t + 1,
          n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          i = parseFloat(t),
          r = parseFloat(e),
          o = Math.random() * (r - i) + i;
      return n ? Math.round(o) : o;
    };

    function r(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }

    var o = function () {
      function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = e.color,
            i = void 0 === n ? "blue" : n,
            r = e.size,
            o = void 0 === r ? 10 : r,
            a = e.dropRate,
            s = void 0 === a ? 10 : a;
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.color = i, this.size = o, this.dropRate = s;
      }

      var e, n, o;
      return e = t, (n = [{
        key: "setup",
        value: function value(t) {
          var e = t.canvas,
              n = t.wind,
              r = t.windPosCoef,
              o = t.windSpeedMax,
              a = t.count;
          return this.canvas = e, this.wind = n, this.windPosCoef = r, this.windSpeedMax = o, this.x = i(-35, this.canvas.width + 35), this.y = i(-30, -35), this.d = i(150) + 10, this.particleSize = i(this.size, 2 * this.size), this.tilt = i(10), this.tiltAngleIncremental = (i(0, .08) + .04) * (i() < .5 ? -1 : 1), this.tiltAngle = 0, this.angle = i(2 * Math.PI), this.count = a + 1, this.remove = !1, this;
        }
      }, {
        key: "update",
        value: function value() {
          this.tiltAngle += this.tiltAngleIncremental * (.2 * Math.cos(this.wind + (this.d + this.x + this.y) * this.windPosCoef) + 1), this.y += (Math.cos(this.angle + this.d) + parseInt(this.dropRate, 10)) / 2, this.x += Math.sin(this.angle), this.x += Math.cos(this.wind + (this.d + this.x + this.y) * this.windPosCoef) * this.windSpeedMax, this.y += Math.sin(this.wind + (this.d + this.x + this.y) * this.windPosCoef) * this.windSpeedMax, this.tilt = 15 * Math.sin(this.tiltAngle - this.count / 3);
        }
      }, {
        key: "pastBottom",
        value: function value() {
          return this.y > this.canvas.height;
        }
      }, {
        key: "draw",
        value: function value() {
          this.canvas.ctx.fillStyle = this.color, this.canvas.ctx.beginPath(), this.canvas.ctx.setTransform(Math.cos(this.tiltAngle), Math.sin(this.tiltAngle), 0, 1, this.x, this.y);
        }
      }, {
        key: "kill",
        value: function value() {
          this.remove = !0;
        }
      }]) && r(e.prototype, n), o && r(e, o), t;
    }();

    function a(t) {
      return (a = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      })(t);
    }

    function s(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }

    function c(t, e) {
      return !e || "object" !== a(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function u(t, e, n) {
      return (u = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var i = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = l(t));) {
            ;
          }

          return t;
        }(t, e);

        if (i) {
          var r = Object.getOwnPropertyDescriptor(i, e);
          return r.get ? r.get.call(n) : r.value;
        }
      })(t, e, n || t);
    }

    function l(t) {
      return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function f(t, e) {
      return (f = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    var h = function (t) {
      function e() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), c(this, l(e).apply(this, arguments));
      }

      var n, i, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && f(t, e);
      }(e, o), n = e, (i = [{
        key: "draw",
        value: function value() {
          u(l(e.prototype), "draw", this).call(this), this.canvas.ctx.arc(0, 0, this.particleSize / 2, 0, 2 * Math.PI, !1), this.canvas.ctx.fill();
        }
      }]) && s(n.prototype, i), r && s(n, r), e;
    }();

    function p(t) {
      return (p = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      })(t);
    }

    function y(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }

    function d(t, e) {
      return !e || "object" !== p(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function v(t, e, n) {
      return (v = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var i = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = b(t));) {
            ;
          }

          return t;
        }(t, e);

        if (i) {
          var r = Object.getOwnPropertyDescriptor(i, e);
          return r.get ? r.get.call(n) : r.value;
        }
      })(t, e, n || t);
    }

    function b(t) {
      return (b = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function m(t, e) {
      return (m = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    var w = function (t) {
      function e() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), d(this, b(e).apply(this, arguments));
      }

      var n, i, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && m(t, e);
      }(e, o), n = e, (i = [{
        key: "draw",
        value: function value() {
          v(b(e.prototype), "draw", this).call(this), this.canvas.ctx.fillRect(0, 0, this.particleSize, this.particleSize / 2);
        }
      }]) && y(n.prototype, i), r && y(n, r), e;
    }();

    function g(t) {
      return (g = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      })(t);
    }

    function O(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }

    function P(t, e) {
      return !e || "object" !== g(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function S(t, e, n) {
      return (S = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var i = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = j(t));) {
            ;
          }

          return t;
        }(t, e);

        if (i) {
          var r = Object.getOwnPropertyDescriptor(i, e);
          return r.get ? r.get.call(n) : r.value;
        }
      })(t, e, n || t);
    }

    function j(t) {
      return (j = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function k(t, e) {
      return (k = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    var x = function (t) {
      function e() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), P(this, j(e).apply(this, arguments));
      }

      var n, i, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && k(t, e);
      }(e, o), n = e, (i = [{
        key: "draw",
        value: function value() {
          var t = this;
          S(j(e.prototype), "draw", this).call(this);

          var n = function n(e, _n, i, r, o, a) {
            t.canvas.ctx.bezierCurveTo(e * (t.particleSize / 200), _n * (t.particleSize / 200), i * (t.particleSize / 200), r * (t.particleSize / 200), o * (t.particleSize / 200), a * (t.particleSize / 200));
          };

          this.canvas.ctx.moveTo(37.5 / this.particleSize, 20 / this.particleSize), n(75, 37, 70, 25, 50, 25), n(20, 25, 20, 62.5, 20, 62.5), n(20, 80, 40, 102, 75, 120), n(110, 102, 130, 80, 130, 62.5), n(130, 62.5, 130, 25, 100, 25), n(85, 25, 75, 37, 75, 40), this.canvas.ctx.fill();
        }
      }]) && O(n.prototype, i), r && O(n, r), e;
    }();

    function _(t) {
      return (_ = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      })(t);
    }

    function E(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }

    function I(t, e) {
      return !e || "object" !== _(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function C(t, e, n) {
      return (C = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var i = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = M(t));) {
            ;
          }

          return t;
        }(t, e);

        if (i) {
          var r = Object.getOwnPropertyDescriptor(i, e);
          return r.get ? r.get.call(n) : r.value;
        }
      })(t, e, n || t);
    }

    function M(t) {
      return (M = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function R(t, e) {
      return (R = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    var z = function (t) {
      function e(t, n) {
        var i;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), (i = I(this, M(e).call(this, t))).imgEl = n, i;
      }

      var n, i, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && R(t, e);
      }(e, o), n = e, (i = [{
        key: "draw",
        value: function value() {
          C(M(e.prototype), "draw", this).call(this), this.canvas.ctx.drawImage(this.imgEl, 0, 0, this.particleSize, this.particleSize);
        }
      }]) && E(n.prototype, i), r && E(n, r), e;
    }();

    function D(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }

    var T = function () {
      function t() {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.cachedImage = null;
      }

      var e, n, r;
      return e = t, (n = [{
        key: "createImageElement",
        value: function value(t) {
          var e = document.createElement("img");
          return e.setAttribute("src", t), e;
        }
      }, {
        key: "getImageElement",
        value: function value(t) {
          return this.cachedImage && t === this.cachedImage.getAttribute("src") || (this.cachedImage = this.createImageElement(t)), this.cachedImage;
        }
      }, {
        key: "create",
        value: function value(t) {
          var e = Object.assign({
            shape: "circle",
            size: 10,
            dropRate: 10,
            colors: ["DodgerBlue", "OliveDrab", "Gold", "pink", "SlateBlue", "lightblue", "Violet", "PaleGreen", "SteelBlue", "SandyBrown", "Chocolate", "Crimson"],
            image: null
          }, t),
              n = i(0, e.colors.length, !0);
          if (e.color = e.colors[n], "circle" === e.shape) return new h(e);
          if ("rect" === e.shape) return new w(e);
          if ("heart" === e.shape) return new x(e);
          if ("image" === e.shape) return new z(e, this.getImageElement(e.image));
          throw Error('Unkown particle shape: "'.concat(e.shape, '"'));
        }
      }]) && D(e.prototype, n), r && D(e, r), t;
    }();

    function F(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }

    var A = function () {
      function t(e) {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.items = [], this.pool = [], this.particleOptions = e, this.particleFactory = new T();
      }

      var e, n, i;
      return e = t, (n = [{
        key: "update",
        value: function value() {
          var t,
              e = this,
              n = [],
              i = [];
          this.items.forEach(function (t) {
            t.update(), t.pastBottom() ? t.remove || (t.setup(e.particleOptions), n.push(t)) : i.push(t);
          }), (t = this.pool).push.apply(t, n), this.items = i;
        }
      }, {
        key: "draw",
        value: function value() {
          this.items.forEach(function (t) {
            return t.draw();
          });
        }
      }, {
        key: "add",
        value: function value() {
          this.pool.length > 0 ? this.items.push(this.pool.pop().setup(this.particleOptions)) : this.items.push(this.particleFactory.create(this.particleOptions).setup(this.particleOptions));
        }
      }, {
        key: "refresh",
        value: function value() {
          this.items.forEach(function (t) {
            t.kill();
          }), this.pool = [];
        }
      }]) && F(e.prototype, n), i && F(e, i), t;
    }();

    function B(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }

    var H = function () {
      function t(e) {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.canvas = e ? document.getElementById(e) : t.createDefaultCanvas(), this.ctx = this.canvas.getContext("2d"), this.isDefault = null == e;
      }

      var e, n, i;
      return e = t, i = [{
        key: "createDefaultCanvas",
        value: function value() {
          var t = document.createElement("canvas");
          return t.style.display = "block", t.style.position = "fixed", t.style.pointerEvents = "none", t.style.top = 0, t.style.width = "100vw", t.style.height = "100vh", t.id = "confetti-canvas", document.querySelector("body").appendChild(t), t;
        }
      }], (n = [{
        key: "clear",
        value: function value() {
          this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.clearRect(0, 0, this.width, this.height);
        }
      }, {
        key: "updateDimensions",
        value: function value() {
          this.isDefault && (this.width === window.innerWidth && this.height === window.innerHeight || (this.canvas.width = window.innerWidth, this.canvas.height = window.innerHeight));
        }
      }, {
        key: "width",
        get: function get() {
          return this.canvas.width;
        }
      }, {
        key: "height",
        get: function get() {
          return this.canvas.height;
        }
      }]) && B(e.prototype, n), i && B(e, i), t;
    }();

    function W(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }

    var q = function () {
      function t() {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.setDefaults();
      }

      var e, n, i;
      return e = t, (n = [{
        key: "setDefaults",
        value: function value() {
          this.killed = !1, this.framesSinceDrop = 0, this.canvas = null, this.canvasId = null, this.W = 0, this.H = 0, this.particles = null, this.particlesPerFrame = 0, this.wind = 0, this.windSpeed = 1, this.windSpeedMax = 1, this.windChange = .01, this.windPosCoef = .002, this.animationId = null;
        }
      }, {
        key: "particleOptions",
        value: function value(t) {
          var e = {
            canvas: this.canvas,
            W: this.W,
            H: this.H,
            wind: this.wind,
            windPosCoef: this.windPosCoef,
            windSpeedMax: this.windSpeedMax,
            count: 0
          };
          return Object.assign(e, t), e;
        }
      }, {
        key: "createParticles",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.particleOptions(t);
          this.particles = new A(e);
        }
      }, {
        key: "start",
        value: function value(t) {
          this.canvas && t.canvasId === this.canvasId || (this.canvas = new H(t.canvasId), this.canvasId = t.canvasId), this.animationId && cancelAnimationFrame(this.animationId), this.createParticles(t), this.canvas.updateDimensions(), this.setParticlesPerFrame(t), this.animationId = requestAnimationFrame(this.mainLoop.bind(this));
        }
      }, {
        key: "setParticlesPerFrame",
        value: function value(t) {
          this.particlesPerFrame = t.particlesPerFrame || 2;
        }
      }, {
        key: "stop",
        value: function value() {
          this.killed = !0, this.particlesPerFrame = 0;
        }
      }, {
        key: "update",
        value: function value(t) {
          this.canvas && t.canvasId !== this.canvasId && (this.stop(), this.canvas.clear(), this.start(t)), this.setParticlesPerFrame(t), this.particles && (this.particles.particleOptions = this.particleOptions(t), this.particles.refresh());
        }
      }, {
        key: "remove",
        value: function value() {
          this.stop(), this.animationId && cancelAnimationFrame(this.animationId), this.canvas.clear(), this.setDefaults();
        }
      }, {
        key: "mainLoop",
        value: function value(t) {
          this.canvas.updateDimensions(), this.canvas.clear(), this.windSpeed = Math.sin(t / 8e3) * this.windSpeedMax, this.wind = this.particles.particleOptions.wind += this.windChange;

          for (var e = this.framesSinceDrop * this.particlesPerFrame; e >= 1;) {
            this.particles.add(), e -= 1, this.framesSinceDrop = 0;
          }

          this.particles.update(), this.particles.draw(), this.killed && !this.particles.items.length || (this.animationId = requestAnimationFrame(this.mainLoop.bind(this))), this.framesSinceDrop += 1;
        }
      }]) && W(e.prototype, n), i && W(e, i), t;
    }();

    n.d(e, "Confetti", function () {
      return q;
    });
    e["default"] = {
      install: function install(t, e) {
        this.installed || (this.installed = !0, t.prototype.$confetti = new q(e));
      }
    };
  },,, function (t, e, n) {
    t.exports = n(0);
  }]);
});